export default "__VITE_ASSET__69f4e60f__"